import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const SEOContext = createContext({ seo: null, refresh: () => {} });

export function SEOProvider({ children }) {
  const [seo, setSeo] = useState(null);

  const load = async () => {
    try {
      const r = await axios.get(`${API}/seo`);
      setSeo(r.data.seo);
    } catch (e) {
      setSeo({});
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <SEOContext.Provider value={{ seo: seo || {}, refresh: load }}>
      {children}
    </SEOContext.Provider>
  );
}

export const useSEO = () => useContext(SEOContext);
